<template>
  <div class="phone-unsupported text-center pa-6">
    <v-icon size="64" color="primary">mdi-cellphone-off</v-icon>
    <h1 class="text-h6 font-weight-bold mt-4">{{ $t('phone-unsupported.title') }}</h1>
    <p class="text-body-2 text--secondary mt-2">{{ $t('phone-unsupported.text') }}</p>
    <v-btn small depressed color="primary" class="mt-4" @click="$auth.logout()">
      <v-icon left small>mdi-logout</v-icon>{{ $t('phone-unsupported.logout') }}
    </v-btn>
  </div>
</template>

<script>
/** Sur téléphone ou tablette, le back-office est fermé : seul le portail terrain s'y ouvre, pour qui y a droit. */
export default {
  name: 'PhoneUnsupported',
}
</script>
